var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    className: "h-[18px] w-[18px]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.822 2.077c.957-1.696 3.4-1.696 4.356 0l2.086 3.7a.5.5 0 0 0 .337.245l4.163.84c1.91.386 2.664 2.71 1.346 4.143l-2.875 3.127a.5.5 0 0 0-.128.396l.488 4.22c.223 1.934-1.753 3.37-3.524 2.56l-3.863-1.768a.5.5 0 0 0-.416 0L7.93 21.308c-1.771.81-3.748-.626-3.524-2.56l.488-4.22a.5.5 0 0 0-.129-.396L1.89 11.005C.572 9.571 1.327 7.248 3.236 6.862l4.164-.84a.5.5 0 0 0 .337-.244zm2.614.982a.5.5 0 0 0-.871 0l-2.086 3.7a2.5 2.5 0 0 1-1.683 1.224l-4.164.84a.5.5 0 0 0-.27.829l2.875 3.127a2.5 2.5 0 0 1 .643 1.979l-.487 4.22a.5.5 0 0 0 .704.511l3.863-1.768a2.5 2.5 0 0 1 2.08 0l3.863 1.768a.5.5 0 0 0 .705-.512l-.488-4.22a2.5 2.5 0 0 1 .643-1.978l2.875-3.127a.5.5 0 0 0-.27-.829l-4.163-.84a2.5 2.5 0 0 1-1.683-1.223z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.7f0e5f2bfc94623f97311b219d634213.svg";
export { ForwardRef as ReactComponent };